<template>  
    <div :style="shu.yangshi" class="zidingyi_wenzi">组合</div> 	
</template>

<script>
export default {
  name: 'zuhe',
  props: {
       shu: {
		   type:Object,
		   default(){
			   return {wenzi:'输入文字',yangshi:{}}
		   }
		}
  },
  
}
</script>



